import brand1 from "../images/brand1.svg";
import brand2 from "../images/brand2.svg";
import brand3 from "../images/brand3.svg";
import brand4 from "../images/brand4.svg";
import brand5 from "../images/brand5.svg";
import brand6 from "../images/brand6.svg";

export const BrandData = [
  {
    id: 1,
    img: brand1,
  },
  {
    id: 2,
    img: brand2,
  },
  {
    id: 3,
    img: brand3,
  },
  {
    id: 4,
    img: brand4,
  },
  {
    id: 5,
    img: brand5,
  },
  {
    id: 6,
    img: brand6,
  },
  {
    id: 7,
    img: brand1,
  },
  {
    id: 8,
    img: brand2,
  },
  {
    id: 9,
    img: brand3,
  },
  {
    id: 10,
    img: brand4,
  },
  {
    id: 11,
    img: brand5,
  },
];
